import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  MoreOutlined,
  PlusOutlined,
  PlusSquareOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Collapse,
  Drawer,
  Dropdown,
  Form,
  Menu,
  Modal,
  message,
} from "antd";
import { Fragment, useEffect, useRef, useState } from "react";
import {
  GET_ALL_TNA_TASK_DATA,
  GET_ALL_UNITS,
  GET_SUPPLIER_ENDPOINT,
  GET_USERS_ENDPOINT,
} from "../../../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../../../apiServices/common";
import HandleNotification from "../../../../../common/Notification";
import {
  cglFormatDate,
  isArrayAndHasValue,
} from "../../../../../utils/functions";
import BulkItemsManage from "../../BulkItemsManage";
import ItemEdit from "../ItemEdit";

const ItemDetails = (props) => {
  const { view, itemDetailsList, setItemDetailsList, TNAStyles, TNAPos, form } =
    props;

  const planCutDates = form?.getFieldValue("plan_cut_dates");
  const planCutDatesRaw = form?.getFieldValue("plan_cut_dates_raw");

  const [itemTypeList, setItemTypeList] = useState([]);
  const [TNATaskList, setTNATaskList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [supplierList, setSupplierList] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [drawerType, setDrawerType] = useState(null);
  const [activeBulkKey, setActiveBulkKey] = useState(null);
  const [foundItems, setFoundItems] = useState(null);
  const [userList, setUserList] = useState(null);

  const { confirm } = Modal;
  const [searchForm] = Form.useForm();
  const { Panel } = Collapse;

  const searchRef = useRef();
  const tableBottomRef = useRef();

  const getTNATaskList = async (value) => {
    let payload = {
      name: value,
      per_page: 300,
    };
    const response = await getData(GET_ALL_TNA_TASK_DATA, undefined, payload);

    if (response) {
      setTNATaskList(response?.data?.data?.data);
    }
  };

  const getItemList = async (value) => {
    const foundItemCategory = itemTypeList.find(
      (category) => category.id === Number(value),
    );

    if (foundItemCategory) {
      setItemList(foundItemCategory?.items);
    }
  };

  const getItemInfo = async (value, index) => {
    let res = await getData(`/api/items/${value}/edit/api`);
    let attributeInfos = res?.data?.data?.attribute_value_info;
    let imagePath = res?.data?.data?.image_path;

    onChangeHandel(attributeInfos, index, "attribute_list");
    onChangeHandel(imagePath, index, "image_path");
  };

  const getUnitList = async () => {
    const bodyData = {
      per_page: 10000,
    };

    let res = await getData(GET_ALL_UNITS, false, bodyData);

    if (res) {
      setUnitList(res?.data?.data?.data);
    }
  };

  const getSupplierList = async () => {
    const bodyData = {
      per_page: 10000,
    };

    let res = await getData(GET_SUPPLIER_ENDPOINT, false, bodyData);

    if (res) {
      setSupplierList(res?.data?.data?.data);
    }
  };

  const onChangeHandel = (val, index, context) => {
    const itemDetailsListCopy = [...itemDetailsList];
    itemDetailsListCopy[index][context] = val;
    setItemDetailsList([...itemDetailsListCopy]);
  };

  const getUserList = async (value) => {
    let payload = {
      name: value,
      per_page: 10000,
    };
    const response = await getData(GET_USERS_ENDPOINT, undefined, payload);

    if (response) {
      setUserList(response?.data?.data?.data);
    }
  };

  useEffect(() => {
    getTNATaskList();
    getUnitList();
    getSupplierList();
    getUserList();
  }, []);

  useEffect(() => {
    if (!drawerType) {
      const itemDetailsListCopy = structuredClone(itemDetailsList);
      const uncheckedList = itemDetailsListCopy?.map((item) => {
        return {
          ...item,
          is_checked: false,
        };
      });
      setItemDetailsList(uncheckedList);
    }
  }, [drawerType]);

  const onEditOpen = (index) => {
    if (view) return;

    const clickedItem = itemDetailsList[index] || null;

    let relatedRows = [];

    if (clickedItem && clickedItem._taskId) {
      relatedRows = itemDetailsList.filter(
        (item) => item._taskId === clickedItem._taskId,
      );
    } else {
      relatedRows = [clickedItem];
    }

    const itemSelected = {
      ...clickedItem,

      task_dates:
        relatedRows.length > 0
          ? relatedRows.map((row) => ({
              days: row.days,
              due_date: row.due_date,
              styles: row.style_ids?.map((id, i) => ({
                id: id,
                style_no: row.style_names?.[i] || "",
              })),
              purchase_orders: row.po_ids?.map((id, i) => ({
                id: id,
                original_po: row.po_names?.[i] || "",
              })),
            }))
          : undefined,
    };

    setIsDrawerOpen(false);

    setTimeout(() => {
      const withIndex = {
        ...itemSelected,
        index: index,
      };
      setDrawerType(null);
      setSelectedItem(withIndex);
      setIsDrawerOpen(true);
    }, 50);
  };

  const onAddOpen = () => {
    setIsDrawerOpen(false);

    setTimeout(() => {
      setDrawerType(null);
      setSelectedItem(null);
      setIsDrawerOpen(true);
    }, 50);
  };

  const closeDrawer = () => {
    setSelectedItem(null);
    setIsDrawerOpen(false);
    setActiveBulkKey(null);
    setDrawerType(null);

    setFoundItems(null);
  };

  const onBulkAddOpen = () => {
    setDrawerType("bulk_add");
    setActiveBulkKey(1);
    setSelectedItem(null);
    setIsDrawerOpen(true);
  };

  const onBulkEditOpen = () => {
    setDrawerType("bulk_edit");
    setActiveBulkKey(null);
    setSelectedItem(null);
    setIsDrawerOpen(true);
  };

  const onAddNewItem = (data) => {
    console.log("data onadd", data);
    const itemDetailsListCopy = structuredClone(itemDetailsList);
    itemDetailsListCopy.push({
      ...data,
      is_add: true,
    });
    setItemDetailsList([...itemDetailsListCopy]);
    scrollToBottom();
    HandleNotification("success", "bottomRight", "Item Added", null);
  };

  const onUpdateItem = (index, updateData) => {
    const itemDetailsListCopy = structuredClone(itemDetailsList);

    const updatedTaskId = itemDetailsListCopy[index]?._taskId;

    const groupIndices = updatedTaskId
      ? itemDetailsListCopy
          .map((item, idx) => (item._taskId === updatedTaskId ? idx : -1))
          .filter((idx) => idx !== -1)
      : [index];

    if (updateData.task_dates && updateData.task_dates.length > 0) {
      const sortedIndices = [...groupIndices].sort((a, b) => b - a);
      for (const idx of sortedIndices) {
        itemDetailsListCopy.splice(idx, 1);
      }

      const insertIndex = Math.min(...groupIndices);
      const newRows = updateData.task_dates.map((dateEntry, dateIdx) => {
        const baseItem = structuredClone(
          itemDetailsList[groupIndices[0]] || {},
        );

        return {
          ...baseItem,

          tna_task_id: updateData.tna_task_id,
          tna_task_name: updateData.tna_task_name,
          responsible_person_id: updateData.responsible_person_id,
          responsible_person_name: updateData.responsible_person_name,
          tna_process_id: updateData.tna_process_id,
          tna_process_title: updateData.tna_process_title,
          tna_department_name: updateData.tna_department_name,
          style_wise: updateData.style_wise,
          po_wise: updateData.po_wise,
          task_dependencies: updateData.task_dependencies,
          task_dependencies_names: updateData.task_dependencies_names,
          is_pcd: updateData.is_pcd,
          is_ship: updateData.is_ship,
          relation_with:
            updateData.style_wise === "Yes"
              ? "Style"
              : updateData.po_wise === "Yes"
              ? "PO"
              : "SC",

          days: dateEntry.days,
          due_date: dateEntry.due_date,
          style_ids:
            updateData.style_wise === "Yes"
              ? dateEntry.styles?.map((s) => s.id)
              : [],
          style_names:
            updateData.style_wise === "Yes"
              ? dateEntry.styles?.map((s) => s.style_no)
              : [],
          po_ids:
            updateData.po_wise === "Yes"
              ? dateEntry.purchase_orders?.map((p) => p.id)
              : [],
          po_names:
            updateData.po_wise === "Yes"
              ? dateEntry.purchase_orders?.map((p) => p.original_po)
              : [],

          _taskId: baseItem._taskId || baseItem.id || Date.now(),
          _isFirstInGroup: dateIdx === 0,
          _groupRowCount: updateData.task_dates.length,
        };
      });

      itemDetailsListCopy.splice(insertIndex, 0, ...newRows);
    } else {
      itemDetailsListCopy[index] = {
        ...itemDetailsListCopy[index],
        days: updateData?.days,
        po_ids: updateData?.po_ids || [],
        po_names: updateData?.po_names || [],
        is_pcd: updateData?.is_pcd,
        is_ship: updateData?.is_ship,
        po_wise: updateData?.po_wise,
        responsible_person_id: updateData?.responsible_person_id,
        responsible_person_name: updateData?.responsible_person_name,
        style_wise: updateData?.style_wise,
        task_dependencies: updateData?.task_dependencies || [],
        task_dependencies_names: updateData?.task_dependencies_names || [],
        tna_department_name: updateData?.tna_department_name,
        tna_process_id: updateData?.tna_process_id,
        tna_process_title: updateData?.tna_process_title,
        tna_task_id: updateData?.tna_task_id,
        tna_task_name: updateData?.tna_task_name,
        style_ids: updateData?.style_ids || [],
        style_names: updateData?.style_names || [],
        relation_with:
          updateData?.style_wise === "Yes"
            ? "Style"
            : updateData?.po_wise === "Yes"
            ? "PO"
            : "SC",

        _taskId:
          itemDetailsListCopy[index]._taskId ||
          itemDetailsListCopy[index].id ||
          Date.now(),
        _isFirstInGroup: true,
        _groupRowCount: 1,
      };
    }

    setItemDetailsList([...itemDetailsListCopy]);
    closeDrawer();

    HandleNotification("success", "bottomRight", "Item Updated", null);
  };

  const onCopyItem = (product, index) => {
    const foundCategory = itemTypeList.find(
      (category) => category.id === Number(product?.item_category_id),
    );
    setItemList(foundCategory?.items);

    setIsDrawerOpen(false);

    setTimeout(() => {
      const itemDetailsListCopy = structuredClone(itemDetailsList);

      if (product._taskId) {
        const relatedItems = itemDetailsList.filter(
          (item) => item._taskId === product._taskId,
        );

        if (relatedItems.length > 0) {
          const newTaskId = Date.now();
          const copiedItems = [];

          relatedItems.forEach((relatedItem, idx) => {
            const copiedItem = structuredClone(relatedItem);
            copiedItem.is_add = true;
            copiedItem.is_copied = true;
            copiedItem._taskId = newTaskId;
            copiedItem._isFirstInGroup = idx === 0;
            copiedItem._groupRowCount = relatedItems.length;
            copiedItems.push(copiedItem);
          });

          const newList = [...itemDetailsListCopy, ...copiedItems];
          setItemDetailsList(newList);

          const taskDates = relatedItems.map((item) => ({
            days: item.days,
            due_date: item.due_date,
            styles:
              item.style_ids?.map((id, i) => ({
                id: id,
                style_no: item.style_names?.[i] || "",
              })) || [],
            purchase_orders:
              item.po_ids?.map((id, i) => ({
                id: id,
                original_po: item.po_names?.[i] || "",
              })) || [],
          }));

          setTimeout(() => {
            setSelectedItem({
              ...relatedItems[0],
              index: newList.length - relatedItems.length,
              is_add: true,
              _taskId: newTaskId,
              task_dates: taskDates,
            });

            setIsDrawerOpen(true);
            scrollToBottom();
          }, 50);
        } else {
          const copiedItem = structuredClone(product);
          copiedItem.is_add = true;
          copiedItem._taskId = Date.now();
          itemDetailsListCopy.push(copiedItem);
          setItemDetailsList([...itemDetailsListCopy]);

          setTimeout(() => {
            setSelectedItem({
              ...copiedItem,
              index: itemDetailsListCopy.length - 1,
              is_add: true,
              is_copied: true,
              task_dates: [
                {
                  days: copiedItem.days,
                  due_date: copiedItem.due_date,
                  styles:
                    copiedItem.style_ids?.map((id, i) => ({
                      id: id,
                      style_no: copiedItem.style_names?.[i] || "",
                    })) || [],
                  purchase_orders:
                    copiedItem.po_ids?.map((id, i) => ({
                      id: id,
                      original_po: copiedItem.po_names?.[i] || "",
                    })) || [],
                },
              ],
            });
            setIsDrawerOpen(true);
            scrollToBottom();
          }, 50);
        }
      } else {
        const copiedItem = structuredClone(product);
        copiedItem.is_add = true;
        itemDetailsListCopy.push(copiedItem);
        setItemDetailsList([...itemDetailsListCopy]);

        setTimeout(() => {
          setSelectedItem({
            ...copiedItem,
            index: itemDetailsListCopy.length - 1,
            is_add: true,
            is_copied: true,
            task_dates: [
              {
                days: copiedItem.days,
                due_date: copiedItem.due_date,
                styles:
                  copiedItem.style_ids?.map((id, i) => ({
                    id: id,
                    style_no: copiedItem.style_names?.[i] || "",
                  })) || [],
                purchase_orders:
                  copiedItem.po_ids?.map((id, i) => ({
                    id: id,
                    original_po: copiedItem.po_names?.[i] || "",
                  })) || [],
              },
            ],
          });
          setIsDrawerOpen(true);
          scrollToBottom();
        }, 50);
      }

      message.success(`Task #${index + 1} Copied Successfully!`);
    }, 50);
  };

  const scrollToBottom = () => {
    tableBottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const removeSelectedProduct = (id, index) => {
    confirm({
      title: "Are you sure delete this item?",
      onOk() {
        const itemDetailsListCopy = structuredClone(itemDetailsList);
        itemDetailsListCopy.splice(index, 1);
        setItemDetailsList([...itemDetailsListCopy]);
        HandleNotification("success", "bottomRight", "Task Deleted", null);
      },
    });
  };

  const menu = (product, index) => {
    return (
      <Menu
        items={[
          {
            label: (
              <div
                className="w-100"
                onClick={() => {
                  onEditOpen(index);
                }}
              >
                <EditOutlined />
                <span className="ml-2">Edit</span>
              </div>
            ),
            key: "0",
          },
          {
            label: (
              <div className="w-100" onClick={() => onCopyItem(product, index)}>
                <CopyOutlined />
                <span className="ml-2">Copy</span>
              </div>
            ),
            key: "1",
          },
          {
            label: (
              <div className="w-100" onClick={onAddOpen}>
                <PlusSquareOutlined />
                <span className="ml-2">Add</span>
              </div>
            ),
            key: "2",
          },
          {
            label: (
              <div
                className="w-100"
                onClick={() => {
                  removeSelectedProduct(product.id, index);
                }}
              >
                <DeleteOutlined style={{ color: "red" }} />
                <span className="ml-2" style={{ color: "red" }}>
                  Delete
                </span>
              </div>
            ),
            key: "3",
          },
        ]}
      />
    );
  };

  const onSearchItem = (values) => {
    const itemDetailsListCopy = structuredClone(itemDetailsList);
    const formCategoryValue = searchForm.getFieldsValue().category;
    const formItemValue = searchForm.getFieldsValue().item;

    const filteredList = itemDetailsListCopy.filter((item) => {
      const category_name = item?.item_category_info?.name?.toLowerCase();
      const item_name = item?.item_info?.name?.toLowerCase();

      if (
        category_name.includes(formCategoryValue?.toLowerCase()) ||
        item_name.includes(formItemValue?.toLowerCase())
      ) {
        return true;
      } else {
        return false;
      }
    });

    isArrayAndHasValue(filteredList) && setItemDetailsList(filteredList);
  };

  const onSearchReset = () => {
    searchForm.resetFields();
    window.location.reload();
  };

  const handleKeyUp = (event) => {
    if (event.keyCode === 13) {
      onSearchItem();
    }
  };

  const renderDrawerTitle = () => {
    switch (drawerType) {
      case "bulk_add":
        return `Bulk Add`;
      case "bulk_edit":
        return `Bulk Edit`;
      default:
        return selectedItem
          ? `Task #${selectedItem?.index + 1} Edit`
          : `Task Add`;
    }
  };

  const addBulkItems = () => {
    const customFoundItems = foundItems?.map((item) => ({ ...item, id: null }));
    const totalData = [...itemDetailsList, ...customFoundItems];
    setItemDetailsList(totalData);
    closeDrawer();
  };

  const editBulkItems = () => {
    const itemDetailsListCopy = structuredClone(itemDetailsList);
    foundItems?.forEach((item) => {
      const foundItemIndex = item?.bulk_edit_id;

      itemDetailsListCopy[foundItemIndex] = item;

      delete itemDetailsListCopy[foundItemIndex]["bulk_edit_id"];
    });
    setItemDetailsList(itemDetailsListCopy);
    closeDrawer();
  };

  const checkAll = (event) => {
    if (event.target.checked) {
      const itemsChecked = itemDetailsList?.map((item) => ({
        ...item,
        is_checked: true,
      }));
      setItemDetailsList(itemsChecked);
      setFoundItems(itemsChecked);
    } else {
      const itemsUnChecked = itemDetailsList?.map((item) => ({
        ...item,
        is_checked: false,
      }));
      setItemDetailsList(itemsUnChecked);
      setFoundItems([]);
    }
  };

  const checkSingle = (event, index, itemId) => {
    const foundItemsCopy = isArrayAndHasValue(foundItems)
      ? [...foundItems]
      : [];
    const itemDetailsListCopy = isArrayAndHasValue(itemDetailsList)
      ? [...itemDetailsList]
      : [];

    const foundItem = itemDetailsListCopy[index];
    foundItem["is_checked"] = foundItem?.is_checked ? false : true;
    setItemDetailsList(itemDetailsListCopy);

    if (event.target.checked) {
      foundItem["bulk_edit_id"] = index;

      foundItemsCopy.push(foundItem);
      setFoundItems(foundItemsCopy);
    } else {
      const foundItemIndex = foundItemsCopy?.findIndex(
        (item) => item?.id === itemId,
      );

      (foundItemIndex || foundItemIndex === 0) &&
        foundItemsCopy.splice(foundItemIndex, 1);
      setFoundItems(foundItemsCopy);
    }
  };

  return (
    <Card
      className="custome-table scrollable-table-container"
      title={
        <span
          style={{
            fontSize: "14px",
            display: isArrayAndHasValue(itemDetailsList) ? "flex" : "none",
          }}
        >
          Task List
        </span>
      }
    >
      {/* <Collapse style={{ marginBottom: 10 }}>
        <Panel header={<b>Filter</b>} key="1">
          <Form form={searchForm} ref={searchRef} onKeyUp={handleKeyUp}>
            <Row gutter={6} style={{ marginBottom: "16px" }}>
              <Col span={4}>
                <Form.Item name="category" label="Category">
                  <Input size="small" />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="item" label="Item">
                  <Input size="small" />
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item label=" ">
                  <Button
                    onClick={onSearchItem}
                    type="primary"
                    size="small"
                    style={{ width: "100%" }}
                  >
                    Search
                  </Button>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item label=" ">
                  <Button
                    onClick={onSearchReset}
                    size="small"
                    style={{ width: "100%" }}
                  >
                    Reset
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Panel>
      </Collapse> */}

      <div
        className="custom-table-scroll"
        style={{ display: "flex", marginBottom: 30 }}
      >
        <div className="custome-table">
          <table>
            {isArrayAndHasValue(itemDetailsList) && (
              <thead>
                <tr>
                  <th className="t-header bc-java">
                    <Checkbox
                      onChange={checkAll}
                      checked={itemDetailsList?.every(
                        (item) => item?.is_checked,
                      )}
                    />
                  </th>
                  <th className="t-header bc-java" style={{ color: "black" }}>
                    SL
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    Task
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    Process
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    Department
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    Style Wise
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    PO Wise
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    Style(s)
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    PO(s)
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    Days
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    Due Date
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    Responsible
                  </th>
                  <th className="t-header bc-java " style={{ color: "black" }}>
                    Dependency
                  </th>
                  {!view && (
                    <>
                      <th
                        className="t-header bc-java "
                        style={{ color: "black" }}
                      >
                        Action
                      </th>
                    </>
                  )}
                </tr>
              </thead>
            )}
            <tbody>
              {isArrayAndHasValue(itemDetailsList) ? (
                <>
                  {itemDetailsList.map((product, index) => {
                    const rowKey = `${product?._taskId || index}-${index}`;

                    const needsRowspan =
                      product?._isFirstInGroup && product?._groupRowCount > 1;

                    const rowspan = needsRowspan
                      ? product._groupRowCount
                      : undefined;

                    return (
                      <tr
                        key={rowKey}
                        onDoubleClick={() => onEditOpen(index)}
                        className={product?.is_add ? "is-added-item" : ""}
                      >
                        {/* Cells that use rowspan - only render in first row of group */}
                        {(product._isFirstInGroup ||
                          product._isFirstInGroup === undefined) && (
                          <>
                            <td className="t-body" rowSpan={rowspan}>
                              <Checkbox
                                onChange={(event) =>
                                  checkSingle(event, index, product?.id)
                                }
                                checked={product?.is_checked}
                              />
                            </td>
                            <td className="t-body" rowSpan={rowspan}>
                              {index + 1}
                            </td>
                            <td className="t-body" rowSpan={rowspan}>
                              {product?.tna_task_name}
                            </td>
                            <td className="t-body" rowSpan={rowspan}>
                              {product?.tna_process_title}
                            </td>
                            <td className="t-body" rowSpan={rowspan}>
                              {product?.tna_department_name}
                            </td>
                            <td className="t-body" rowSpan={rowspan}>
                              {product?.style_wise}
                            </td>
                            <td className="t-body" rowSpan={rowspan}>
                              {product?.po_wise}
                            </td>
                          </>
                        )}

                        {/* Cells that vary for each row in a group */}
                        <td className="t-body">
                          {isArrayAndHasValue(product?.style_names)
                            ? `${product?.style_names
                                ?.slice(0, 2)
                                ?.join(", ")}${
                                product?.style_names?.length > 2 ? "..." : ""
                              }`
                            : "N/A"}
                        </td>
                        <td className="t-body">
                          {isArrayAndHasValue(product?.po_ids)
                            ? `${product?.po_ids
                                ?.map((item) => {
                                  const foundTask = TNAPos?.find(
                                    (itm) => itm?.id === item,
                                  );
                                  return foundTask?.original_po;
                                })
                                ?.slice(0, 2)
                                ?.join(", ")}${
                                product?.po_ids?.length > 2 ? "..." : ""
                              }`
                            : "N/A"}
                        </td>
                        <td className="t-body">{product?.days}</td>
                        <td className="t-body">
                          {cglFormatDate(product?.due_date) || "N/A"}
                        </td>

                        {/* Cells that should appear once per group */}
                        {(product._isFirstInGroup ||
                          product._isFirstInGroup === undefined) && (
                          <>
                            <td className="t-body" rowSpan={rowspan}>
                              {product?.responsible_person_name}
                            </td>
                            <td className="t-body" rowSpan={rowspan}>
                              {isArrayAndHasValue(product?.task_dependencies)
                                ? `${product?.task_dependencies
                                    ?.map((item) => {
                                      const foundTask = itemDetailsList.find(
                                        (itm) => itm?.tna_task_id === item,
                                      );
                                      return foundTask?.tna_task_name;
                                    })
                                    ?.slice(0, 2)
                                    ?.join(", ")}${
                                    product?.task_dependencies?.length > 2
                                      ? "..."
                                      : ""
                                  }`
                                : "N/A"}
                            </td>
                            {!view && (
                              <td className="t-body" rowSpan={rowspan}>
                                <div className="cursore-pointer">
                                  <Dropdown overlay={menu(product, index)}>
                                    <MoreOutlined
                                      style={{ fontSize: "20px" }}
                                    />
                                  </Dropdown>
                                </div>
                              </td>
                            )}
                          </>
                        )}
                      </tr>
                    );
                  })}
                </>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div ref={tableBottomRef} />

      <Button
        style={{ width: "200px", position: "fixed", bottom: "3vh" }}
        type="primary"
        className="mt-2"
        icon={<PlusOutlined />}
        size="small"
        hidden={view || isDrawerOpen}
        onClick={onAddOpen}
      >
        Add Task
      </Button>

      <Drawer
        title={renderDrawerTitle()}
        placement="right"
        onClose={closeDrawer}
        open={isDrawerOpen}
        width={
          drawerType === "bulk_add" || drawerType === "bulk_edit" ? 1000 : 950
        }
        maskStyle={{
          backdropFilter: "blur(0px)",
          backgroundColor: "rgba(0,0,0,0)",
        }}
        destroyOnClose={true}
      >
        {drawerType === "bulk_add" || drawerType === "bulk_edit" ? (
          <BulkItemsManage
            foundItems={foundItems}
            setFoundItems={setFoundItems}
            activeBulkKey={activeBulkKey}
            setActiveBulkKey={setActiveBulkKey}
            unitList={unitList}
            supplierList={supplierList}
            addBulkItems={addBulkItems}
            drawerType={drawerType}
            editBulkItems={editBulkItems}
          />
        ) : (
          <ItemEdit
            selectedItem={selectedItem}
            getTNATaskList={getTNATaskList}
            TNATaskList={TNATaskList}
            getItemList={getItemList}
            getItemInfo={getItemInfo}
            itemList={itemList}
            unitList={unitList}
            supplierList={supplierList}
            closeDrawer={closeDrawer}
            onUpdateItem={onUpdateItem}
            onAddNewItem={onAddNewItem}
            isDrawerOpen={isDrawerOpen}
            userList={userList}
            itemDetailsList={itemDetailsList}
            TNAStyles={TNAStyles}
            TNAPos={TNAPos}
            getUserList={getUserList}
            planCutDates={planCutDates || planCutDatesRaw}
          />
        )}
      </Drawer>
    </Card>
  );
};

export default ItemDetails;
